import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "../../lib/api";
import { toast } from "sonner";
import Logo from "../../components/Logo";

export default function AdminLogin() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        if (loading) return;
        setLoading(true);
        try {
            const r = await api.post("/auth/login", { email, password });
            if (r.data?.token) {
                localStorage.setItem("cc_admin_token", r.data.token);
            }
            toast.success("Welcome back");
            navigate("/admin");
        } catch (err) {
            toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <main className="min-h-screen bg-[#FFF7FB] flex items-center justify-center px-4 py-16" data-testid="admin-login-page">
            <div className="w-full max-w-md bg-white border border-blush/20 p-8 md:p-10 shadow-[0_30px_80px_rgba(236,0,140,0.15)]">
                <Link to="/" className="block mb-6">
                    <Logo variant="dark" className="h-12 mx-auto" />
                </Link>
                <h1 className="font-display text-3xl text-ink mb-2 text-center">Admin Login</h1>
                <p className="text-sm text-ink-soft mb-8 text-center">Cake Central CMS</p>
                <form onSubmit={submit} className="space-y-5">
                    <div>
                        <label className="block text-[10px] tracking-[0.25em] uppercase text-ink-soft mb-2">Email</label>
                        <input
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full px-4 py-3 border border-[#EAE3DE] focus:outline-none focus:border-blush"
                            data-testid="admin-email"
                        />
                    </div>
                    <div>
                        <label className="block text-[10px] tracking-[0.25em] uppercase text-ink-soft mb-2">Password</label>
                        <input
                            type="password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full px-4 py-3 border border-[#EAE3DE] focus:outline-none focus:border-blush"
                            data-testid="admin-password"
                        />
                    </div>
                    <button type="submit" disabled={loading} className="btn-pink w-full disabled:opacity-60" data-testid="admin-login-btn">
                        {loading ? "Signing in…" : "Sign in"}
                    </button>
                </form>
            </div>
        </main>
    );
}
